






















import { container } from 'tsyringe';
import { defineComponent, toRefs } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import { ModelManager } from '../prototyping/model';

export default defineComponent({
  name: 'RPCLog',
  components: {
    ViewContainer,
  },
  setup() {
    const globalModel = container.resolve(ModelManager).global;
    const { clearLogs } = globalModel;
    const { unityRPCLog, webViewRPCLog } = toRefs(globalModel.state);

    return {
      clearLogs,
      unityRPCLog,
      webViewRPCLog,
    };
  },
});
